import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../store/rootReducer';

export const useNotificationsComponentAllSelector = getSimpleDataSelector(
    (state: RootState) => state.notificationCenterComponent,
);
